import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  title:{
    fontFamily: 'Roboto-Bold',
    fontSize: 20,
    borderBottom: '1px solid #DADEE1',
    padding: '16px',
    color: '#626970',
    margin: 0
  },
  container: {
    margin: 0,
    padding: 0,
  },
  firstSettingsSection: {
    borderRight: '1px solid #DADEE1',
  },
  dashboardSettingsSection: {
    padding: theme.spacing(2),

    [theme.breakpoints.down('sm')]: {
      borderTop: '1px solid #DADEE1',
      '&': {
        borderBottom: '1px solid #DADEE1'
      },
      '&:last-child': {
        borderBottom: 'none'
      }
    },
  },
  reportSaveSection: {
    borderTop: '1px solid #DADEE1',
    padding: theme.spacing(2),
  },
  header: {
    fontSize: 14,
    fontFamily: 'Roboto-Bold',
    color: '#313D44',
  },
  highlightedName: {
    color: theme.palette.primary.main,
  },
  contentDisabled: {
    color: 'rgba(0, 0, 0, 0.38)',
    pointerEvents: 'none',
    '& > span': {
      color: 'rgba(0, 0, 0, 0.38) !important',
    }
  },
  groupItemActions: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    float: 'right',

    '& > span': {
      color: theme.palette.primary.main,
      fontFamily: 'Roboto-Medium',
      fontSize: 12,
      textTransform: 'none !important',
      display: 'flex',
      alignItems: 'center',

      '& > i': {
        margin: 'auto',
        marginRight: 6
      },
    },
  },
  checkbox: {
    paddingLeft: 0,
    marginLeft: -2,
  },
  copySettingsHeader: {
    marginBottom: 0
  },
  formLabel: {
    color: '#313D44',
    fontFamily: 'Roboto-Bold',
    fontSize: 14,
    marginBottom: 8,
    whiteSpace: 'nowrap !important',
    width: '100%'
  },
  benchmarkLabel: {
    fontFamily: "'Roboto-Bold'",
    fontSize: 13,
    color: '#4D4F5C',
    margin: 0
  },
  chartSettingsSectionWrapper: {
    marginTop: theme.spacing(2)
  },
  periodSelector: {
      [theme.breakpoints.up('xl')]: {
        '& > div': {
          justifyContent: 'space-between',
          '& > div': {
            width: 294
          }
        }
    }
  },
  portfoliosSelectorContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    flexDirection: 'row',

    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  }
}));